import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, filter } from 'rxjs';
import { ITEM_DELETED_EVENT } from '@common/const/navigation.constants';
import { AlertErrorService } from '@core/service/alert-error.service';
import { HasAnyAccessDirective } from '@shared/directives/has-any-access.directive';
import { TmwTranslateDirective } from '@shared/directives/translate.directive';

/**
 * Actions Modifier / Supprimer d'un ecran de consultation, affichees selon les
 * habilitations de l'utilisateur (memes droits que les icones de la liste).
 * Le lien par defaut suppose les routes soeurs ':id/view' et ':id/edit'.
 */
@Component({
  standalone: true,
  selector: 'tmw-consult-actions',
  template: `
    @if (editLink()) {
      <button type="button" *hasAnyAccess="resource() + '_Update'; module: module()" class="btn btn-primary {{ btnClass() }}" [routerLink]="editLink()">
        <i class="bi bi-pencil"></i>&nbsp;<span tmwTranslate="entity.action.edit">Modifier</span>
      </button>
    }
    @if (deleteAction()) {
      <button type="button" *hasAnyAccess="resource() + '_Delete'; module: module()" class="btn btn-danger {{ btnClass() }}" (click)="delete()">
        <i class="bi bi-trash3"></i>&nbsp;<span tmwTranslate="entity.action.delete">Supprimer</span>
      </button>
    }
  `,
  styles: [':host { display: contents; }'],
  imports: [RouterLink, HasAnyAccessDirective, TmwTranslateDirective],
})
export class TmwConsultActionsComponent {
  /** Prefixe des droits, ex. 'referentiels' pour referentiels_Update / referentiels_Delete. */
  resource = input.required<string>();
  module = input<string>('MDL_GENERAL');
  /** Lien vers le formulaire de modification ; null pour masquer le bouton. */
  editLink = input<any[] | string | null>(['../edit']);
  /** Suppression de l'element consulte ; non renseigne pour masquer le bouton. */
  deleteAction = input<(() => Observable<unknown>) | undefined>(undefined);
  btnClass = input<string>('px-4 py-2 mx-1');

  private readonly modalService = inject(NgbModal);
  private readonly alertService = inject(AlertErrorService);

  delete(): void {
    const action = this.deleteAction();
    if (!action) {
      return;
    }
    // import dynamique : DeleteDialogComponent depend du SharedModule qui declare ce composant
    import('@common/dialog/delete-dialog/delete-dialog.component').then(({ DeleteDialogComponent }) => {
      const modalRef = this.modalService.open(DeleteDialogComponent, { size: 'md', backdrop: 'static' });
      // la fenetre de confirmation n'affiche son contenu que si un element lui est passe
      modalRef.componentInstance.elementData = {};
      modalRef.closed.pipe(filter((reason) => reason === ITEM_DELETED_EVENT)).subscribe(() => {
        action().subscribe({
          next: () => {
            this.alertService.showOperationSuccess();
            history.back();
          },
        });
      });
    });
  }
}
